var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopMenuAccount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-profile-7986550",
    d: "M67.59,103.12a4.387,4.387,0,0,1,3.031,7.462,4.282,4.282,0,0,1-7.318-3.09A4.33,4.33,0,0,1,67.59,103.12Zm-7.024,14.762a8.447,8.447,0,0,1,14.048,0,.535.535,0,0,0,.874-.616,9.5,9.5,0,0,0-15.8,0,.535.535,0,0,0,.874.616Zm9.3-12.714a3.24,3.24,0,1,0,0,4.644,3.329,3.329,0,0,0,0-4.644Z",
    transform: "translate(-59.59 -103.12)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopMenuAccount);
export default __webpack_public_path__ + "static/media/top-menu-account.daa12df1f121b780cf94d2312d0fd4e3.svg";
export { ForwardRef as ReactComponent };